import _ from 'lodash';

/**
 * Checks if field type is a relation
 *
 * @param   {string}  fieldType
 * @return  {Boolean}
 */
export const isRelationFieldType = (fieldType) => {
    const relationFieldTypes = ['OneToOne', 'OneToMany', 'ManyToOne', 'Relationship', 'Asset'];

    return _.indexOf(relationFieldTypes, fieldType) > -1;
};
